import api from "./api";
import AuthService from "../views/services/auth.service";

/**
 * @param {String} endpoint relative endpoint
 * @param {object} body request body
 * @param {String} method method can be ["GET","POST","PUT", "DELETE"] | Default GET
 * @param {boolean} transformBody whether to transform the request body from JSON to FormData | Default false
 */
export async function queryApi(
  endpoint,
  body = null,
  method = "GET",
  transformBody = false
) {
  let error = null;
  let result = null;
  try {
    //Create our config, with the method as the method passed and the new endpoint
    let config = {
      method,
      url: `${process.env.REACT_APP_API_URL}/${endpoint}`,
    };

    const token = AuthService.getCurrentAuthUser().token; // Change to localStorage or any other storage if necessary

    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`
      };
    }

    if (body) {
      // Si nous avons un corps et que la m�thode est GET
      if (method.toUpperCase() === "GET") {
        config = {
          ...config,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // Ajouter le token ici
          },
          data: body,
        };
      }

      // Pour les m�thodes POST, PUT, PATCH
      if (["POST", "PUT", "PATCH"].includes(method.toUpperCase())) {
        if (transformBody) {
          // Si nous avons besoin de transformer le corps en FormData (par exemple pour t�l�charger des fichiers)
          let bodyFormData = new FormData();
          for (let [key, value] of Object.entries(body)) {
            if (value) {
              if (Array.isArray(value)) {
                value.forEach((v) => bodyFormData.append(key, v));
              } else {
                bodyFormData.append(key, value);
              }
            }
          }
          config = {
            ...config,
            headers: {
              "Content-Type": "multipart/form-data", // Type de contenu FormData
              "Authorization": `Bearer ${token}`, // Ajouter le token ici aussi
            },
            data: bodyFormData,
          };
        } else {
          // Si nous n'avons pas besoin de transformer le corps, envoyer le corps en JSON
          config = {
            ...config,
            headers: {
              "Content-Type": "application/json", // Type de contenu JSON
              "Authorization": `Bearer ${token}`, // Ajouter le token ici aussi
            },
            data: body,
          };
        }
      }
    }

    // Setting authorization token if available with each request
    // This example uses sessionStorage, feel free to change it to cookie storage or something else.

    // const token = sessionStorage.getItem("token");
    // if (token)
    //   config.headers = { ...config.headers, Authorization: `Bearer ${token}` };

    // console.log(`Requesting : ${config.url}`)
    // console.log(config)

    const res = await api(config);
    result = res.data;
  } catch (e) {
    // To differentiate between validation errors and response errors,
    // check whether the "errors" key is defined or not in the returned error from this function.

    if (e.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      error = e.response.data;
      //   console.log(e.message);
      //   console.log(error);
    } else {
      // 1) The request was made but no response was received
      // OR
      // 2) Something went wrong in setting up the request that triggered an Error

      //   console.log(e.request);
      //   console.log(e.message);
      error = e.message;
    }
  }

  return [result, error];
}
